import * as React from 'react';
import {TextProps, ViewProps} from 'react-native';
import {IconSvg} from '../../../../../assets/icons';

export enum DropdownMenuItemTypes {
  default,
  splitter,
}

export interface DropdownMenuItem {
  type?: DropdownMenuItemTypes;
  label?: string;
  icon?: IconSvg;
  onPress?: () => void;
  light?: boolean;
  style?: TextProps['style'];
}

export interface Props {
  items: DropdownMenuItem[];
  children?: React.ReactNode;
  style?: ViewProps['style'];
}

export interface IStateProps extends Props {
  isActive: boolean;
  onClick: () => void;
  close: () => void;
}
